import styled from 'styled-components';
import { Comment } from 'antd';

export const ContainerComment = styled(Comment)`
  .ant-comment-content-author-time {
    color: #747373;
    white-space: nowrap;
    cursor: auto;
  }

  .ant-comment-nested {
    margin-left: 0px;
  }
`;
